import { render, staticRenderFns } from "./SurveyDetails.vue?vue&type=template&id=13f7d1e0&scoped=true"
import script from "./SurveyDetails.vue?vue&type=script&lang=js"
export * from "./SurveyDetails.vue?vue&type=script&lang=js"
import style0 from "./SurveyDetails.vue?vue&type=style&index=0&id=13f7d1e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f7d1e0",
  null
  
)

export default component.exports